const ServicesOverview = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container-custom text-center max-w-4xl">

        <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
          What We Do
        </span>

        <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
          Complete Construction &
          Property Solutions
        </h2>

        <p className="text-gray-600 mt-8 leading-8">
          AZ Construction provides end-to-end solutions
          including construction, development, property
          dealing and liaisoning services. Our experienced
          team ensures every project is delivered with
          quality, transparency and professionalism.
        </p>

      </div>
    </section>
  );
};

export default ServicesOverview;